
<align small-gap>
  <pill-dropdown
    v-model="localSort"
    :options="optionsArray"
  />

  <icon-button
    v-show="activeOption"
    :tooltip="directionTooltip"
    :icon="directionIcon"
    @click="changeDirection"
  />
</align>
